import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import SearchInput from 'components/commons/inputs/SearchInput/SearchInput';
import Dropdown from 'components/commons/dropdowns/Dropdown';
import Button from 'components/commons/buttons/button/Button';
import { ReactComponent as Ic_Pencil } from 'resources/icons/Ic_Pencil.svg';
import { ReactComponent as Ic_Favorite } from 'resources/icons/Ic_Star_Black--filled.svg';
import './saveFavoriteModal.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { categoriaFavoriteState } from 'redux/slices/favoritesSlice';
import { useTranslate } from 'context/languageContext';

export default function SaveFavoriteModal({
  onClose,
  onAccept,
  title,
  text,
  secondaryText = '',
  onAliasChange,
  onIconChange,
  item,
}) {
  const [itemSelected, setItemSelected] = useState(0);
  const [aliasName, setAliasName] = useState('');
  const favoritesCategories = useSelector(categoriaFavoriteState);
  const t = useTranslate();

  const handleIconChange = (selected) => {
    const defaultAlias = favoritesCategories.find((v)=> Number(selected) === Number(v.id));
    if(defaultAlias) {
      setAliasName(defaultAlias?.name);
      handleAliasChange(defaultAlias?.name );
    };
    setItemSelected(selected);
    const fav = { ...item, typeId: selected, categoryId: selected, alias:defaultAlias?.name ?? '', name:item.name, street: item?.name };
    onIconChange(fav);
  };
  const handleAliasChange = (alias) => {
    const fav = { ...item, alias };
    onAliasChange(fav);
  };

  const prepareItems = () => {
    let items = [{ id: 0, txt: t('lb_selecciona_un_icono'), value: 0, icon: Ic_Favorite }];
    const formatFavCategories = favoritesCategories?.length
      ? favoritesCategories?.map((categoria) => {
          return {
            id: categoria.id,
            txt: categoria.name,
            value: categoria.id,
            iconPromise: categoria.iconId,
          };
        }).sort((a, b) =>a.id - b.id)
      : [];
    items = [...items, ...formatFavCategories];
    return items;
  };

  return (
    <ModalInfo
      title=''
      width='88%'
      height='auto'
      closeAction={() => onClose()}
    >
      <article className='box-favorite-modal'>
        <h1 className='favorite-title'>{title}</h1>
        <p className='favorite-text'>
          {text}
          {secondaryText && <p className='favorite-secondary-text'>{secondaryText}</p>}
        </p>
        <Dropdown
          className='favorite-select'
          icon={itemSelected === 0 ? Ic_Favorite : null}
          imagePromise={itemSelected !== 0 ? prepareItems()[itemSelected]?.icon : null}
          items={prepareItems()}
          onChange={(e) => handleIconChange(e)}
          firstDisabled
        />
        <SearchInput
          name='favorite-name-input-filter'
          className='favorite-name-label'
          iconRight={Ic_Pencil}
          placeholder={t('lb_nombre')}
          value={aliasName}
          actionOnChange={(e) => handleAliasChange(e)}
        />
        <div className='favorite-box-buttons'>
          <Button
            title={t('lb_cancelar')}
            style={{ color: '#4B5858', border: 'solid 1.5px #489ACA' }}
            className='favorite-btn'
            onClick={() => onClose()}
          />
          <Button
            title={t('lb_aceptar')}
            background='#489ACA'
            style={{
              color: 'white',
            }}
            className='favorite-btn'
            onClick={() => onAccept()}
          />
        </div>
      </article>
    </ModalInfo>
  );
}
